module.exports = __webpack_public_path__ + "img/bg.24a58d9e.jpeg";